import { motion } from 'framer-motion';
import { Building2, ShoppingCart, GraduationCap, Heart } from 'lucide-react';

const partnerTypes = [
  {
    icon: Building2,
    title: 'Toy & Product Companies',
    description: 'Global and regional partnerships for physical products and licensing.',
  },
  {
    icon: ShoppingCart,
    title: 'Retail & Distribution',
    description: 'Direct relationships with major retail chains and specialty stores.',
  },
  {
    icon: Heart,
    title: 'Brand Collaborations',
    description: 'Custom character development and sonic branding for partner brands.',
  },
  {
    icon: GraduationCap,
    title: 'Education & Wellbeing',
    description: 'Therapeutic, educational, and children\'s wellness applications.',
  },
];

const GLOW_COLORS = ['glow-pink', 'glow-cyan', 'glow-orange', 'glow-purple'];

export const Partnerships = () => {
  return (
    <section
      id="partnerships"
      data-testid="partnerships-section"
      className="section-padding relative overflow-hidden"
    >
      <div className="soundmoo-container relative z-10">
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-12"
        >
          <motion.span className="text-sm font-medium tracking-widest uppercase text-white/60 mb-4 block">
            Partnerships
          </motion.span>
          <h2 className="text-4xl md:text-5xl font-bold text-white font-['Outfit'] mb-5">
            Built to Collaborate
          </h2>
          <p className="text-lg text-white/80 max-w-2xl mx-auto">
            We work alongside brands, distributors, and creative partners to bring character IP to life. 
            Whether licensing originals or developing custom worlds — we're your creative studio partner.
          </p>
        </motion.div>

        {/* Partner Types Grid */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 mb-12"
        >
          {partnerTypes.map((partner, index) => (
            <motion.div
              key={partner.title}
              data-testid={`partner-type-${index}`}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
              className={`glow-card ${GLOW_COLORS[index % GLOW_COLORS.length]} p-5 text-center cursor-pointer`}
            >
              <div className="w-12 h-12 rounded-xl bg-white/20 flex items-center justify-center mx-auto mb-3 transition-transform relative z-10">
                <partner.icon className="w-6 h-6 text-white" />
              </div>
              <h4 className="text-base font-semibold text-white font-['Outfit'] mb-1 relative z-10">
                {partner.title}
              </h4>
              <p className="text-sm text-white/70 relative z-10">
                {partner.description}
              </p>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};
